import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InputLimit from './InputLimit';

type Props = TextFieldProps & {
  value?: string;
  maxLength: number;
  helperText?: string;
  withLimitHelper?: boolean;
  /**
   * When true (default), the field hard-blocks input past `maxLength` via the native `maxLength`
   * attribute. Set to false to allow typing past the limit and rely on Yup validation instead
   * (matches the behavior of the event description field, which highlights the error in red
   * rather than truncating input).
   */
  hardLimit?: boolean;
};

const useFormHelperTextStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(0.5, 0, 0, 2),
    '&:last-child': {
      flexShrink: 0,
    },
  },
}));

const LimitedTextField: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const {
    value,
    maxLength,
    inputProps,
    FormHelperTextProps,
    helperText,
    withLimitHelper = true,
    hardLimit = true,
    ...rest
  } = props;
  const { classes: formHelperTextClasses } = useFormHelperTextStyles();
  return (
    <TextField
      {...rest}
      value={value}
      inputProps={{ ...inputProps, ...(hardLimit && { maxLength }) }}
      FormHelperTextProps={{ ...FormHelperTextProps, classes: formHelperTextClasses }}
      helperText={
        <>
          <span>{helperText}</span>
          {withLimitHelper && <InputLimit value={value} maxLength={maxLength} />}
        </>
      }
    />
  );
};

export default LimitedTextField;
